var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Storage } from '../../../../lib/localstorege.service';
import { Api } from './game.operations.api';
import { currencyFormat, dateTimeFormat, initialLeftMenu, sportsMenu, useForceUpdate, } from '../../../../lib/misc.functions';
import { modalServiceSubject } from '../../../../components/modal/modal';
import { useNavigate } from 'react-router-dom';
import { isMobile } from '../../../../app/Routes';
import { GameOperationsSelect } from '../../widgets/selected';
import Clock from '../../../../assets/feather/clock.svg';
import CheckCircle from '../../../../assets/feather/check-circle.svg';
import MinusCircle from '../../../../assets/feather/minus-circle.svg';
import { env } from '../../../../definitions/global.vars';
import Modal from 'react-modal';
import ExitIcon from '../../../../assets/feather/x-circle.svg';
// import logoOynaKazan from "../../../../assets/img/oyna_kazan.png";
import logoOynaKazan from '../../../../assets/img/oyna_kazan.png';
var paramStates = {
    'kartlarim': 0,
    'kazananlar': 2,
    'kaybedenler': 3,
};
var states = {
    0: 'Onaysız',
    1: 'Devam eden',
    2: 'Kazanan',
    3: 'Kaybeden',
    5: 'Hatalı',
};
var couponStatus = {
    0: _jsx("img", { src: Clock, className: 'invert-color', width: 16 }, void 0),
    1: _jsx("img", { src: Clock, className: 'invert-color', width: 16 }, void 0),
    2: _jsx("img", { src: CheckCircle, width: 16 }, void 0),
    3: _jsx("img", { src: MinusCircle, width: 16 }, void 0),
    5: _jsx("img", { src: ExitIcon, width: 16 }, void 0),
};
var refetchTimer;
export function Scatch(prop) {
    var navigate = useNavigate();
    var _a = useState([]), drawList = _a[0], setDrawList = _a[1];
    var _b = useState(null), shownDraw = _b[0], setShownDraw = _b[1];
    var forceUpdate = useForceUpdate();
    // @ts-ignore
    var ticketStatus = paramStates[prop.params.couponId];
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        fetchDraws();
    }, [ticketStatus]);
    var fetchDraws = function () {
        try {
            // @ts-ignore
            document.getElementById('loadingPageAnimation').style.display = 'block';
        }
        catch (e) {
        }
        var postParams = {
            token: Storage.get('token'),
            has_scratch: ticketStatus === 0 ? 0 : 1,
        };
        if (ticketStatus !== 0) {
            postParams['status'] = ticketStatus;
        }
        Api.start('post', "".concat(env.core_api, "/order/api/kazi-kazan/kuponlarim/"), postParams, true).then(function (res) {
            // @ts-ignore
            document.getElementById('loadingAnimation').style.display = 'none';
            if (res.status === true) {
                var pending_1 = res.data.filter(function (el) { return el.pending_count > 0; });
                if (pending_1.length > 0) {
                    refetchTimer = setTimeout(function () {
                        fetchDraws();
                    }, 5000);
                }
                else {
                    clearTimeout(refetchTimer);
                }
                setDrawList(res.data);
            }
            else {
                modalServiceSubject.next({
                    title: 'Beklenmedik bir sorun oluştu',
                    content: res.message,
                    confirm: {
                        cancel: { label: 'Tamam' },
                    },
                    timeout: 3000,
                });
            }
        });
    };
    var showDrawTickets = function (draw) {
        var postParams = {
            token: Storage.get('token'),
            type: 'get_draw',
            draw_id: draw.draw_id,
        };
        Api.start('post', "".concat(env.core_api, "/order/api/kazi-kazan/kuponlarim/"), postParams, true).then(function (res) {
            // console.log(res)
            if (res.status === true) {
                if (ticketStatus === 0) {
                    draw['tickets'] = res.data.filter(function (t) { return t.has_scratched === false; });
                }
                else {
                    draw['tickets'] = res.data.filter(function (t) { return t.has_scratched === true && t.status === ticketStatus; });
                }
                setShownDraw(draw);
            }
            else {
                setShownDraw(null);
                modalServiceSubject.next({
                    title: 'Beklenmedik bir sorun oluştu',
                    content: res.message,
                    confirm: {
                        cancel: { label: 'Tamam' },
                    },
                    timeout: 3000,
                });
            }
        });
    };
    var scratchCard = function (ticket) {
        var postParams = {
            token: Storage.get('token'),
            type: 'scratch',
            coupons: ticket.id,
        };
        Api.start('post', "".concat(env.core_api, "/order/api/kazi-kazan/kazi/"), postParams, true).then(function (res) {
            // console.log(res)
            if (res.status === true) {
                ticket.has_scratched = true;
                setDrawList(drawList.filter(function (el) {
                    if (shownDraw.draw_id === el.draw_id) {
                        el.has_scratch_count += 1;
                    }
                    return el;
                }));
            }
            else {
                setShownDraw(null);
                modalServiceSubject.next({
                    title: 'Beklenmedik bir sorun oluştu',
                    content: res.message,
                    confirm: {
                        cancel: { label: 'Tamam' },
                    },
                    timeout: 3000,
                });
            }
        }).catch(function (e) {
            console.log(e),
                modalServiceSubject.next({
                    title: 'Beklenmedik bir sorun oluştu',
                    content: 'Lütfen internet bağlantınızı kontrol edip tekrar deneyiniz. ',
                    confirm: {
                        cancel: { label: 'Tamam' },
                    },
                    timeout: 3000,
                });
        });
    };
    var closeModal = function () {
        setShownDraw(null);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "widget card" }, { children: [_jsxs("div", __assign({ className: "header" }, { children: [isMobile ? _jsx(GameOperationsSelect, {}, void 0) : _jsx("h1", { children: "Oyna Kazan Kartlar\u0131m" }, void 0), _jsxs("ul", __assign({ className: "tabs clearfix" }, { children: [_jsx("li", __assign({ className: 'btn btn-outline-warning tab-border   ' + (ticketStatus === 0 ? ' active' : ''), onClick: function () { return navigate('/hesabim/oyna-kazan/kartlarim'); } }, { children: "Kartlar\u0131m" }), void 0), _jsx("li", __assign({ className: 'btn btn-outline-warning tab-border ' + (ticketStatus === 2 ? ' active' : ''), onClick: function () { return navigate('/hesabim/oyna-kazan/kazananlar'); } }, { children: "Kazanan Kartlar" }), void 0), _jsx("li", __assign({ className: 'btn btn-outline-warning tab-border ' + (ticketStatus === 3 ? ' active' : ''), onClick: function () { return navigate('/hesabim/oyna-kazan/kaybedenler'); } }, { children: "Kaybeden Kartlar" }), void 0)] }), void 0)] }), void 0), _jsx("div", __assign({ id: "InfiniteScroll", className: "body p-2 p-sm-0" }, { children: drawList && drawList.length > 0 ? _jsx(_Fragment, { children: _jsxs("table", __assign({ className: "table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "\u00C7ekili\u015F" }), void 0), _jsx("th", __assign({ className: "hidden-sm" }, { children: "\u00C7ekili\u015F Tarihi" }), void 0), ticketStatus === 0 ? _jsx(_Fragment, { children: _jsx("th", { children: "Ald\u0131\u011F\u0131m Bilet" }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0), ticketStatus === 2 ? _jsx(_Fragment, { children: _jsx("th", { children: "Kazanan Bilet" }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0), ticketStatus === 3 ? _jsx(_Fragment, { children: _jsx("th", { children: "Kay\u0131p Bilet" }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0), _jsx("th", { className: "hidden-sm" }, void 0)] }, void 0) }, void 0), _jsx("tbody", { children: drawList.map(function (order, key) {
                                            return (_jsxs("tr", __assign({ onClick: function () {
                                                    showDrawTickets(order);
                                                } }, { children: [_jsx("td", __assign({ className: "text-left" }, { children: _jsx("span", __assign({ className: 'd-block fw-bold' }, { children: order.draw ? order.draw.name : null }), void 0) }), void 0), _jsx("td", __assign({ className: "hidden-sm vertical-top" }, { children: order.draw ? dateTimeFormat(order.draw.drawDate) : null }), void 0), ticketStatus === 0 ? _jsx(_Fragment, { children: _jsxs("td", __assign({ className: "vertical-top" }, { children: [order.lost_count + order.won_count - order.has_scratch_count, " adet"] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), ticketStatus === 2 ? _jsx(_Fragment, { children: _jsxs("td", __assign({ className: "vertical-top" }, { children: [order.won_count, " adet"] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), ticketStatus === 3 ? _jsx(_Fragment, { children: _jsxs("td", __assign({ className: "vertical-top" }, { children: [order.lost_count, " adet"] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), _jsx("td", __assign({ className: "vertical-top hidden-sm text-right" }, { children: _jsx("button", __assign({ className: "btn btn-small btn-primary" }, { children: "Kartlar\u0131m\u0131 G\u00F6ster" }), void 0) }), void 0)] }), "drawList_".concat(key)));
                                        }) }, void 0)] }), void 0) }, void 0) : _jsx(_Fragment, { children: _jsx("p", __assign({ className: "p-5 text-center m-3" }, { children: "G\u00F6sterilecek bir kay\u0131t yok!" }), void 0) }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ id: "loadingAnimation", className: "text-center py-5" }, { children: _jsxs("div", __assign({ className: "lds-roller", style: { position: 'unset' } }, { children: [_jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0), _jsx("div", {}, void 0)] }), void 0) }), void 0), _jsx(Modal, __assign({ isOpen: shownDraw !== null ? true : false, onRequestClose: closeModal, style: {
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        maxWidth: 'calc(100vw - 40px)',
                        width: '920px',
                        padding: '0px',
                        maxHeight: 'calc(100vh - 100px)',
                        transform: 'translate(-50%, -50%)',
                        background: 'var(--color-bg-white)',
                    },
                }, contentLabel: "" }, { children: shownDraw ? _jsxs("div", __assign({ className: "card coupon lotteryTickets" }, { children: [_jsxs("div", __assign({ className: "card-title p-2" }, { children: [_jsx("h3", __assign({ className: "m-0" }, { children: "Kartlar\u0131m" }), void 0), _jsx("div", __assign({ className: 'float-right' }, { children: _jsx("img", { src: ExitIcon, width: 24, className: 'float-right cursor-p invert-color', onClick: function () { return closeModal(); } }, void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: "card-body p-2 p-sm-0" }, { children: _jsx("div", __assign({ className: "row" }, { children: shownDraw.tickets.filter(function (e) { return e.approve_code !== null; }).map(function (ticket, key) {
                                    var nonUnique = 0;
                                    var prizePayout = 0;
                                    var totalPrize = ticket.draw.prizes.map(function (e) {
                                        return Number(e.prizeCount) * Number(e.approxPrizeValue.replace('₺', '').replace('.', '').replace(',', '.'));
                                    }).reduce(function (t, x) { return t + x; });
                                    return (_jsx("div", __assign({ className: "oyna-kazan-kart ".concat(ticket.status === 2 ? 'won' : (ticket.status === 3 ? 'lose' : '')) }, { children: _jsxs("div", { children: [_jsxs("h2", { children: [_jsx("span", { children: _jsxs("div", { children: [_jsx("b", { children: "Bilet no:" }, void 0), " ", ticket.approve_code] }, void 0) }, void 0), ticket.draw.title] }, void 0), _jsx("div", __assign({ className: "selections" }, { children: ticket.selections.map(function (s, skey) {
                                                        nonUnique = ticket.selections.filter(function (o) {
                                                            if (o.value === s.value) {
                                                                return o;
                                                            }
                                                        }).length;
                                                        if (nonUnique === 3) {
                                                            prizePayout = Number(s.value);
                                                        }
                                                        return _jsx("div", __assign({ className: "".concat(nonUnique === 3 && ticket.has_scratched === true ? 'won' : (ticket.has_scratched === false && s.has_scratched !== true ? 'non-scratched' : '')), onClick: function () {
                                                                var unScratchedSelections = ticket.selections.filter(function (o) { return o.has_scratched === true; }).length;
                                                                console.log(unScratchedSelections);
                                                                if (unScratchedSelections === 5) {
                                                                    scratchCard(ticket);
                                                                }
                                                                s.has_scratched = true;
                                                                forceUpdate();
                                                            } }, { children: ticket.has_scratched === true || s.has_scratched === true ? s.value : '' }), "".concat(key, "_se_").concat(skey));
                                                    }) }), void 0), _jsxs("div", __assign({ className: "footer" }, { children: [ticket.has_scratched === false ? _jsx(_Fragment, { children: _jsx("button", __assign({ className: "btn btn-warning float-right", onClick: function () {
                                                                    scratchCard(ticket);
                                                                } }, { children: "Hemen Kaz\u0131" }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), ticket.has_scratched === true && prizePayout > 0 ? _jsx(_Fragment, { children: _jsxs("button", __assign({ className: "btn btn-success float-right" }, { children: ["Kazand\u0131 : ", currencyFormat(prizePayout), "\u20BA"] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), ticket.has_scratched === true && prizePayout === 0 ? _jsx(_Fragment, { children: _jsx("button", __assign({ className: "btn btn-danger float-right" }, { children: "Kaybetti" }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), _jsx("img", { src: logoOynaKazan }, void 0)] }), void 0)] }, void 0) }), "ticketList_".concat(key)));
                                }) }), void 0) }), void 0)] }), void 0) : _jsx(_Fragment, {}, void 0) }), void 0)] }, void 0));
}
